import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import PaginationButtons from './PaginationButtons';
import { useLogsContext } from '../LogsContext';
import LayoutWrapper from './LayoutWrapper';

const useStyles = buildUseStyles('Logs', ((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  top: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
  },
})));

const Logs = () => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const classes = useStyles();
  const { logsCollection, refreshLogsCollection } = useLogsContext();

  return (
    <Box
      className={classes.root}
    >
      <Box className={classes.top}>
        <Box className={classes.buttonContainer}>
          <IconButton
            onClick={async () => {
              await refreshLogsCollection();
              logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'refreshed event logs');
            }}
            icon={RefreshIcon}
            title={'Refresh Logs'}
          />
        </Box>
        <MetaCollectionFormInline
          collection={logsCollection}
          padding={'none'}
          margin={'none'}
          FormProps={{
            layout: LayoutWrapper,
            readonly: true,
          }}
        />
      </Box>
      <PaginationButtons
        collection={logsCollection}
      />
    </Box>
  );
};

export default Logs;
